import DownloadDocumentsBlock from "theme/libs/wordpress/content/cmsBlocks/DownloadDocumentsBlock";
import ModuleMarginWrapper from "theme/components/wrappers/ModuleMarginWrapper";
import PropTypes from "prop-types";
import React from "react";

const DownloadDocumentsModule = ({ content, isCustomerService }) => (
    <ModuleMarginWrapper marginAfter={isCustomerService ? "none" : "lg"}>
        <DownloadDocumentsBlock content={content} isCustomerService={isCustomerService} />
    </ModuleMarginWrapper>
);

DownloadDocumentsModule.propTypes = {
    content: PropTypes.object,
    isCustomerService: PropTypes.bool,
};

DownloadDocumentsModule.defaultProps = {
    content: undefined,
    isCustomerService: false,
};

export default DownloadDocumentsModule;
